import { NavLink, Link, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import css from './styles';
import { DownloadLink, DownloadModal, DownloadProvider } from './download';

const NAV = [
  ['/', 'Home'],
  ['/results', 'Results'],
  ['/winners', 'Winners'],
  ['/rates', 'Game Rates'],
  ['/how-to-play', 'How to Play'],
];

function PublicLayoutInner({ title, description, children }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  // Close the drawer whenever the route changes, otherwise it stays open
  // over the new page after a tap.
  useEffect(() => { setMenuOpen(false); }, [pathname]);

  useEffect(() => {
    const prev = document.body.style.backgroundColor;
    document.body.style.backgroundColor = '#070d16';
    return () => {
      document.body.style.backgroundColor = prev;
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>{title ? `${title} | VIP Kalyan` : 'VIP Kalyan'}</title>
        {description ? <meta name="description" content={description} /> : null}
        <meta property="og:title" content={title ? `${title} | VIP Kalyan` : 'VIP Kalyan'} />
        {description ? <meta property="og:description" content={description} /> : null}
        <meta property="og:type" content="website" />
      </Helmet>

      <style>{css}</style>

      <div className="dk">
        <header className="hdr">
          <div className="wrap hdr-in">
            <Link to="/" className="brand">
              <span className="logo">VK</span> VIP Kalyan
            </Link>
            <nav className="nav">
              {NAV.map(([to, label]) => (
                <NavLink key={to} to={to} end={to === '/'} className={({ isActive }) => (isActive ? 'on' : '')}>
                  {label}
                </NavLink>
              ))}
            </nav>

            <button
              type="button"
              className={`burger ${menuOpen ? 'on' : ''}`}
              aria-label={menuOpen ? 'Close menu' : 'Open menu'}
              aria-expanded={menuOpen}
              onClick={() => setMenuOpen((v) => !v)}
            >
              <span />
            </button>
          </div>

          <div className={`drawer ${menuOpen ? 'open' : ''}`}>
            <nav>
              {NAV.map(([to, label]) => (
                <NavLink key={to} to={to} end={to === '/'} className={({ isActive }) => (isActive ? 'on' : '')}>
                  {label}
                </NavLink>
              ))}
              <DownloadLink className="dl-item" onClick={() => setMenuOpen(false)}>
                ↓ Download App
              </DownloadLink>
            </nav>
          </div>
        </header>

        <main>{children}</main>

        <footer className="ftr">
          <div className="wrap">
            <div className="ftr-in">
              <div style={{ maxWidth: 300 }}>
                <div className="brand" style={{ marginBottom: 10 }}>
                  <span className="logo">VK</span> VIP Kalyan
                </div>
                <p style={{ margin: 0 }}>Live matka results, game rates and winners — updated every day.</p>
              </div>
              <div>
                <h4>Pages</h4>
                <ul>
                  {NAV.map(([to, label]) => (
                    <li key={to}><Link to={to}>{label}</Link></li>
                  ))}
                </ul>
              </div>
              <div>
                <h4>Admin</h4>
                <ul><li><Link to="/admin">Admin panel</Link></li></ul>
              </div>
            </div>

            <div className="note" style={{ marginBottom: 22 }}>
              <p><span className="age">18+</span>&nbsp; This site is for adults aged 18 and over. Games involve real money and you can lose what you stake. Only play with what you can afford to lose.</p>
              <p>Set a limit before you start and stop when you reach it. Never play to win back money you have already lost, and never borrow to play.</p>
              <p>Availability of real-money gaming depends on where you live, and it is your responsibility to know the law that applies to you.</p>
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 14, flexWrap: 'wrap',
              borderTop: '1px solid rgba(255,255,255,.07)', paddingTop: 18 }}>
              <span>© {new Date().getFullYear()} VIP Kalyan</span>
              <span>18+ only · Play responsibly</span>
            </div>
          </div>
        </footer>

        {/* Fixed on every page, so the APK is one tap away wherever a visitor is. */}
        <div className="dlbar">
          <div className="txt">
            <b>VIP Kalyan for Android</b>
            Results, wallet and bids on your phone
          </div>
          <DownloadLink className="btn">↓ Download</DownloadLink>
        </div>

        <DownloadModal />
      </div>
    </>
  );
}

export default function PublicLayout(props) {
  return (
    <DownloadProvider>
      <PublicLayoutInner {...props} />
    </DownloadProvider>
  );
}
